import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {materialColorOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {z} from "zod/v4-mini"
import {vec3} from "#material/types/vector"
import {imageTextureExtensionSchema, imageTextureInterpolation, imageTextureProjection} from "#material/nodes/texture/tex-image/types"

export interface DistanceTextureSockets extends MaterialNodeSockets {
    inputs: {
        vector: "point"
    }
    settings: {
        extension: "string"
        forceOriginalResolution: "boolean"
        height: "float"
        innerValue: "float"
        interpolation: "string"
        mergeRange: "float"
        meshObjectData: "any"
        projection: "string"
        projectionBlend: "float"
        range: "float"
        smoothPasses: "int"
        targets: "any"
        uvChannel: "int"
        width: "float"
        vector: "point"
    }
    outputs: {
        color: "color"
    }
}
export const distanceTextureDefinition = {
    exchangeFormat: {
        nodeName: null,
    },
    nodeClass: "DistanceTexture",
    ui: {
        color: "#4987af",
        items: [],
        label: "Distance Texture",
        support: {
            cycles: true,
            three: false,
        },
    },
    validation: {
        returns: z.strictObject({color: materialColorOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({
                vector: optionalMaterialInput,
            }),
            settings: z.strictObject({
                extension: z.optional(imageTextureExtensionSchema),
                forceOriginalResolution: z.optional(z.boolean()),
                height: z.optional(z.number()),
                innerValue: z.optional(z.number()),
                interpolation: z.optional(imageTextureInterpolation),
                mergeRange: z.optional(z.number()),
                meshObjectData: z.optional(z.unknown()),
                projection: z.optional(imageTextureProjection),
                projectionBlend: z.optional(z.number()),
                range: z.optional(z.number()),
                smoothPasses: z.optional(z.number()),
                targets: z.optional(z.array(z.unknown())),
                uvChannel: z.optional(z.number()),
                width: z.optional(z.number()),
                vector: z.optional(vec3),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<DistanceTextureSockets>
